import { X } from "lucide-react";
import { useState } from "react";
import {useLanguageStore} from "../store/languageStore";

export default function DesignModal(props) {
    const [isOpen, setIsOpen] = useState(true);
    const {language} = useLanguageStore()
    const isArabic = language === 'ar'

    const closeModal = () => {
        props.close(false);
    };

    if (!props.visbale) return <></>
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" dir={isArabic ? 'rtl' : 'ltr'}>
            <div className="bg-white rounded-lg shadow-xl w-full max-w-5xl overflow-hidden">
                <div className="flex flex-col md:flex-row">
                    {/* Left side image */}
                    <div className="md:w-3/5 m-5 ">
                        <div className="w-full ">
                            <img loading="lazy"
                                src={props?.modalInfo?.image}
                                alt="Worker in blue uniform"
                                className="w-full h-full object-cover rounded-xl"
                            />
                        </div>
                    </div>

                    {/* Right side content */}
                    <div className="md:w-3/5 p-6 relative" >
                        {/* Close button */}
                        <button
                            onClick={closeModal}
                            className={`absolute top-4 ${isArabic ? 'left-4' : 'right-4'}  text-gray-500 hover:text-gray-700`}
                        >
                            <X size={24} />
                        </button>

                        {/* Content */}
                        <div className="pr-6">
                            <h2 className="text-3xl font-bold mb-6 text-gray-800">
                                {isArabic ? props?.modalInfo?.services_name_ar : props?.modalInfo?.services_name_en}
                            </h2>


                                <p  className="text-gray-600 mb-6">
                                    {isArabic ? props?.modalInfo?.description_ar : props?.modalInfo?.description_en}
                                </p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}